import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { LanguageModule } from '@language';
import {
    ShAutoFocusDirective,
    ShClickOutsideDirective,
    ShDroppanelSelectComponent,
    ShFormMultiSelectModule,
    ShIconModule,
    ShTreeViewerComponent
} from '@stylehaven/components';
import { ThesaurusSearchComponent } from './component/thesaurus-search/thesaurus-search.component';
import { ThesaurusSuggestionDetailComponent } from './component/thesaurus-suggestion-detail/thesaurus-suggestion-detail.component';
import { ThesaurusTagListComponent } from './component/thesaurus-tag-list/thesaurus-tag-list.component';
import { ThesaurusTreeMultipleComponent } from './component/thesaurus-tree-multiple/thesaurus-tree-multiple.component';
import { ThesaurusTreeSingleComponent } from './component/thesaurus-tree-single/thesaurus-tree-single.component';
import { ThesaurusConceptContainerComponent } from './containers/thesaurus-concept-container/thesaurus-concept.component';

@NgModule({
    declarations: [
        ThesaurusConceptContainerComponent,
        ThesaurusSuggestionDetailComponent,
        ThesaurusTreeSingleComponent,
        ThesaurusTreeMultipleComponent,
        ThesaurusSearchComponent,
        ThesaurusTagListComponent
    ],
    imports: [
        CommonModule,
        RouterModule,
        ReactiveFormsModule,
        LanguageModule,
        ShClickOutsideDirective,
        ShDroppanelSelectComponent,
        ShFormMultiSelectModule,
        ShIconModule,
        ShTreeViewerComponent,

        ShAutoFocusDirective
    ],
    exports: [
        ThesaurusConceptContainerComponent,
        ThesaurusSuggestionDetailComponent,
        ThesaurusTreeSingleComponent,
        ThesaurusTreeMultipleComponent,
        ThesaurusSearchComponent,
        ThesaurusTagListComponent
    ]
})
export class ThesaurusModule {}

export { ThesaurusSuggestionDetailComponent } from './component/thesaurus-suggestion-detail/thesaurus-suggestion-detail.component';
export { ThesaurusTagListComponent } from './component/thesaurus-tag-list/thesaurus-tag-list.component';
export { ThesaurusTreeMultipleComponent } from './component/thesaurus-tree-multiple/thesaurus-tree-multiple.component';
export { ThesaurusTreeSingleComponent } from './component/thesaurus-tree-single/thesaurus-tree-single.component';
export { ThesaurusConceptContainerComponent } from './containers/thesaurus-concept-container/thesaurus-concept.component';
